import React, { useState, useEffect } from "react";
import Box from "@mui/material/Box";
import { Grid } from "@mui/material";
import { useTheme } from "@mui/material/styles";
import useMediaQuery from "@mui/material/useMediaQuery";
import Card from "@mui/material/Card";
import CardMedia from "@mui/material/CardMedia";
import Button from "@mui/material/Button";
import Typography from "@mui/material/Typography";
import { Stack } from "@mui/system";
import cardData from "../../data/mtlearningcard.json";
import CircularProgress from "@mui/material/CircularProgress";
import mailData from "../../data/mailData";
import Accordion from "@mui/material/Accordion";
import AccordionDetails from "@mui/material/AccordionDetails";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import MuiAccordionSummary from "@mui/material/AccordionSummary";
import { styled } from "@mui/material/styles";
import LinearProgress, {
  linearProgressClasses,
} from "@mui/material/LinearProgress";
import Modal from "@mui/material/Modal";
import { useMsal } from "@azure/msal-react";
import axios from "axios";
import "./LearningCards.css";

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 670,
  bgcolor: "background.paper",
  border: "2px solid #754BFF",
  boxShadow: 24,
  p: "30px",
};
function MTLearningCards() {
  const [modalContent, setModalContent] = useState({});
  const [openModal, setOpenModal] = useState(false);
  const { instance } = useMsal();
  const [username, setuserName] = useState(null);
  const [courseData, setCourseData] = useState("");
  const Max_Length = 140;
  const [openCaseStudy, setOpenCaseStudy] = React.useState(false);
  const handleOpenCaseStudy = () => setOpenCaseStudy(true);
  const handleCloseCaseStudy = () => setOpenCaseStudy(false);
  const baseURL = "https://atci.lkm.accenture.com/shell-university-apis";

  const activeAccount = instance.getActiveAccount();
  const handler = () => {
    axios
      .get(`${baseURL}/data`, {
        headers: {
          "Cache-Control": "no-cache",
          Accept: "application/json",
          Pragma: "no-cache",
          Expires: "0",
          Authorization: localStorage.getItem("token"),
          "Content-Type": "application/json",
        },
      })
      .then((res) => {
        setCourseData(res.data);
      })
      .catch((err) => {
        console.log(err);
      });
  };
  useEffect(() => {
    handler();
  }, []);
  useEffect(() => {
    if (activeAccount) {
      setuserName(activeAccount.idTokenClaims.enterpriseID);
    } else {
      setuserName(null);
    }
  }, [activeAccount]);

  const userDetails =
    courseData !== "" &&
    courseData.filter((item) => item["Enterprise ID"] === username);
  const mlData =
    userDetails !== false &&
    cardData.flatMap((item) =>
      userDetails.filter((elem) => elem["Board Name"].includes(item.title))
    );

  // completion status of each course
  const awarecourseData = cardData.flatMap(
    (item) =>
      item.Type === "Trainings" &&
      item.title === "Manual Testing Aware" &&
      item.Content.map((content) =>
        content.courses.map(function (obj) {
          return mlData &&
            mlData
              .map((elem) => elem && elem["Activity Name"])
              .includes(obj.name)
            ? { ...obj, percent: 100 }
            : { ...obj, percent: 0 };
        })
      )
  );
  // console.log(awarecourseData)
  const equippedcourseData = cardData.flatMap(
    (item) =>
      item.Type === "Trainings" &&
      item.title === "Manual Testing Equipped" &&
      item.Content.map((content) =>
        content.courses.map(function (obj) {
          return mlData &&
            mlData.map((elem) => elem["Activity Name"]).includes(obj.name)
            ? { ...obj, percent: 100 }
            : { ...obj, percent: 0 };
        })
      )
  );
  const competentcourseData = cardData.flatMap(
    (item) =>
      item.Type === "Trainings" &&
      item.title === "Manual Testing Competent" &&
      item.Content.map((content) =>
        content.courses.map(function (obj) {
          return mlData &&
            mlData.map((elem) => elem["Activity Name"]).includes(obj.name)
            ? { ...obj, percent: 100 }
            : { ...obj, percent: 0 };
        })
      )
  );

  // completion of courses in content level
  const awarepercentagestring = awarecourseData.map((item) =>
    item !== false
      ? item.reduce((acc, cutvalue) => {
          return Math.round(acc + cutvalue.percent / item.length);
        }, 0)
      : ""
  );
  const awarepercentage = awarepercentagestring.filter((elem) => elem !== "");
  const equippedpercentagestring = equippedcourseData.map((item) =>
    item !== false
      ? item.reduce((acc, cutvalue) => {
          return Math.round(acc + cutvalue.percent / item.length);
        }, 0)
      : ""
  );
  const equippedpercentage = equippedpercentagestring.filter(
    (elem) => elem !== ""
  );
  const competentpercentagestring = competentcourseData.map((item) =>
    item !== false
      ? item.reduce((acc, cutvalue) => {
          return Math.round(acc + cutvalue.percent / item.length);
        }, 0)
      : ""
  );
  const competentpercentage = competentpercentagestring.filter(
    (elem) => elem !== ""
  );

  // sub-parent level
  const awaresubParentData = cardData.map(
    (obj, index) =>
      obj.Type === "Trainings" &&
      obj.title === "Manual Testing Aware" &&
      obj.Content.map((content, index) => {
        return { ...content, percent: awarepercentage[index] };
      })
  );
  const equippedsubParentData = cardData.map(
    (obj, index) =>
      obj.Type === "Trainings" &&
      obj.title === "Manual Testing Equipped" &&
      obj.Content.map((content, index) => {
        return { ...content, percent: equippedpercentage[index] };
      })
  );
  const competentsubParentData = cardData.map(
    (obj, index) =>
      obj.Type === "Trainings" &&
      obj.title === "Manual Testing Competent" &&
      obj.Content.map((content, index) => {
        return { ...content, percent: competentpercentage[index] };
      })
  );

  let countPercent100Aware = 0;
  let totalCountAware = 0;
  let countPercent100Equipped = 0;
  let totalCountEquipped = 0;
  let countPercent100Competent = 0;
  let totalCountCompetent = 0;

  // Loop through the data array and check if each element is an array
  for (const element of awarecourseData) {
    if (Array.isArray(element)) {
      // If it's an array, iterate through its objects
      for (const obj of element) {
        if (obj.percent === 100) {
          countPercent100Aware++;
        }
        totalCountAware++;
      }
    }
  }

  // Calculate the percentage
  const awareFinalPercentage = (countPercent100Aware / totalCountAware) * 100;
  // Loop through the data array and check if each element is an array
  for (const element of equippedcourseData) {
    if (Array.isArray(element)) {
      // If it's an array, iterate through its objects
      for (const obj of element) {
        if (obj.percent === 100) {
          countPercent100Equipped++;
        }
        totalCountEquipped++;
      }
    }
  }

  // Calculate the percentage
  const equippedFinalPercentage =
    (countPercent100Equipped / totalCountEquipped) * 100;
  // Loop through the data array and check if each element is an array
  for (const element of competentcourseData) {
    if (Array.isArray(element)) {
      // If it's an array, iterate through its objects
      for (const obj of element) {
        if (obj.percent === 100) {
          countPercent100Competent++;
        }
        totalCountCompetent++;
      }
    }
  }

  // Calculate the percentage
  const competentFinalPercentage =
    (countPercent100Competent / totalCountCompetent) * 100;
  //    overall percentage calculation of each phase
  const mlAwareData = cardData.map((item) =>
    item.Type === "Trainings" && item.title === "Manual Testing Aware"
      ? {
          ...item,
          CompletionPercent: awareFinalPercentage,
        }
      : ""
  );
  const mlEquippedData = cardData.map((item) =>
    item.Type === "Trainings" && item.title === "Manual Testing Equipped"
      ? {
          ...item,
          CompletionPercent: equippedFinalPercentage,
        }
      : ""
  );
  const mlCompetentData = cardData.map((item) =>
    item.Type === "Trainings" && item.title === "Manual Testing Competent"
      ? {
          ...item,
          CompletionPercent: competentFinalPercentage,
        }
      : ""
  );

  const handleOpen = (id) => {
    setOpenModal(true);
    const clickedCourseDetail = cardData.filter((obj) => {
      return obj.id === id;
    });
    setModalContent(clickedCourseDetail[0]);
  };

  const handleClose = () => {
    setOpenModal(false);
  };
  const theme = useTheme();
  const isSmallScreen = useMediaQuery(theme.breakpoints.down("sm"));
  const AccordionSummary = styled((props) => (
    <MuiAccordionSummary {...props} />
  ))(({ theme }) => ({
    backgroundColor: "#E4E4E4",
    height: "45px !important",
  }));
  const BorderLinearProgress = styled(LinearProgress)(({ theme }) => ({
    height: 5,
    borderRadius: 5,
    [`&.${linearProgressClasses.colorPrimary}`]: {
      backgroundColor:
        theme.palette.grey[theme.palette.mode === "light" ? 200 : 800],
    },
    [`& .${linearProgressClasses.bar}`]: {
      borderRadius: 5,
      backgroundColor: theme.palette.mode === "light" ? "#A409FF" : "#308fe8",
    },
  }));
  const phasesData = (item) => {
    return (
      <Grid item xs={3}>
        <Card sx={{ position: "relative" }} tabIndex={0}>
          <>
            <CardMedia
              component="img"
              height="120"
              image={item.image}
              alt="card-image"
            />
            <Stack direction="column" spacing={3} sx={{ top: "0px" }}>
              <div className="infoText-Wrap">
                <Box sx={{ color: "white", marginTop: "2px" }}>
                  <h5
                    className={
                      item.title === "Manual Testing Aware"
                        ? "color1"
                        : item.title === "Manual Testing Equipped"
                        ? "color2"
                        : item.title === "Manual Testing Competent"
                        ? "color3"
                        : "color4"
                    }
                    style={{ fontWeight: "600" }}
                  >
                    <span>{item["phase-name"]}</span>
                  </h5>
                </Box>
                <Box className="info-Duration">
                  {item && (
                    <Typography sx={{ fontSize: "12px", marginTop: "10px" }}>
                      {item.description.length > Max_Length ? (
                        <div>
                          {`${item.description.substring(0, Max_Length)}...`}
                          <span
                            className="knowmore"
                            onClick={() => handleOpen(item["id"])}
                            tabIndex={0}
                          >
                            Know More
                          </span>
                        </div>
                      ) : (
                        <div>
                          {item.description}
                          <span
                            className="knowmore"
                            onClick={() => handleOpen(item["id"])}
                            tabIndex={0}
                          >
                            Know More
                          </span>
                        </div>
                      )}
                    </Typography>
                  )}
                  <Modal
                    hideBackdrop
                    open={openModal}
                    onClose={handleClose}
                    aria-labelledby="child-modal-title"
                    closeAfterTransition
                    aria-describedby="child-modal-description"
                    className="modal-container"
                  >
                    <Box className="model">
                      <div className="model_heading">
                        <h5 className="paramodel">
                          {modalContent["phase-name"]}
                        </h5>
                        <span
                          className="close_btn_model"
                          onClick={handleClose}
                          tabIndex={0}
                        >
                          Close
                        </span>
                      </div>
                      <hr />
                      <div className="mainRootWrapper">
                        <div>
                          <h6>Description :</h6>
                          <p>{modalContent["description"]}</p>
                        </div>
                        <div>
                          <h6>
                            Target Audience :{" "}
                            <span>{modalContent["target-audience"]}</span>
                          </h6>
                        </div>
                        {/* <div>
             <h6>Pre-requisite :</h6>
             <p dangerouslySetInnerHTML={{ __html: modalContent["pre-requisite"] }}></p>
            </div> */}
                      </div>
                    </Box>
                  </Modal>
                  <Box
                    sx={{ position: "relative", display: "inline-flex" }}
                    className="circleContainer"
                  >
                    <CircularProgress
                      sx={{
                        height: "65px !important",
                        width: "65px !important",
                        zIndex: "1",
                      }}
                      className={
                        item.title === "Manual Testing Aware"
                          ? "innerbg1"
                          : item.title === "Manual Testing Equipped"
                          ? "innerbg2"
                          : item.title === "Manual Testing Competent"
                          ? "innerbg3"
                          : "innerbg4"
                      }
                      variant="determinate"
                      value={item.CompletionPercent}
                    />
                    <Box
                      sx={{
                        top: 0,
                        left: 0,
                        bottom: 0,
                        right: 0,
                        position: "absolute",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        background: "white",
                        borderRadius: "50%",
                        height: "65px",
                        width: "65px",
                        padding: "2px",
                      }}
                      className={
                        item.title === "Manual Testing Aware"
                          ? "progressAndDuration1"
                          : item.title === "Manual Testing Equipped"
                          ? "progressAndDuration2"
                          : item.title === "Manual Testing Competent"
                          ? "progressAndDuration3"
                          : "progressAndDuration4"
                      }
                    >
                      <Typography
                        className={
                          item.title === "Manual Testing Aware"
                            ? "innerBorder1"
                            : item.title === "Manual Testing Equipped"
                            ? "innerBorder2"
                            : item.title === "Manual Testing Competent"
                            ? "innerBorder3"
                            : "innerBorder4"
                        }
                        sx={{
                          fontSize: "0.55rem",
                          color: "#6D398F",
                          textAlign: "center",
                          fontWeight: "600",
                        }}
                        variant="caption"
                        component="div"
                        color="text.secondary"
                      >
                        <span className="completionNum">{`${Math.round(
                          item.CompletionPercent
                        )}%`}</span>{" "}
                        complete
                      </Typography>
                    </Box>
                  </Box>
                  <Box className="durationWrapNew">
                    {item.id === "4" ? (
                      ""
                    ) : (
                      // <img className="weekImage" src={item.duration}></img>
                      <stack>
                        <img
                          className="hourGlass"
                          src="images/Hourglass.png"
                          alt="sand clock icon"
                        ></img>{" "}
                        <Typography className="hourText">
                          <span className="smallText">Duration</span>
                          <span
                            className={
                              item.title === "Manual Testing Aware"
                                ? "bottom-color1"
                                : item.title === "Manual Testing Equipped"
                                ? "bottom-color2"
                                : item.title === "Manual Testing Competent"
                                ? "bottom-color3"
                                : "bottom-color4"
                            }
                          >
                            {Math.round(item.hour)} Hours
                          </span>
                        </Typography>
                      </stack>
                    )}
                  </Box>
                </Box>
              </div>
            </Stack>
          </>
          <Box
            sx={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              width: "100%",
            }}
          >
            <Accordion sx={{ width: "100%", background: "#E4E4E4" }}>
              <AccordionSummary
                expandIcon={
                  <ExpandMoreIcon
                    sx={{
                      fontSize: "1.9rem",
                      border: "solid 1.3px #6D398F",
                      color: "#6D398F",
                    }}
                  />
                }
              >
                <Typography sx={{ color: "#6D398F" }} className="training-type">
                  Courses
                </Typography>
              </AccordionSummary>
              <AccordionDetails
                sx={{ width: "100%" }}
                className="mainAccDetails"
              >
                <Box sx={{ width: "100%", background: "white", px: "15px" }}>
                  {item.title === "Manual Testing Aware" ? (
                    awaresubParentData[0].map((content, i) => {
                      return (
                        <Stack
                          direction="column"
                          mt={1.5}
                          className="acc-stack"
                          sx={{ overflowY: "auto" }}
                        >
                          <>
                            <Accordion className="mainAccordion">
                              <AccordionSummary
                                sx={{
                                  backgroundColor: "#FFF",
                                  margin: "0px",
                                  padding: "0px",
                                }}
                                expandIcon={
                                  <ExpandMoreIcon
                                    sx={{ fontSize: "1rem", color: "#0041F0" }}
                                  />
                                }
                              >
                                <Stack
                                  direction="row"
                                  sx={{
                                    display: "flex",
                                    justifyContent: "space-between",
                                    width: "100%",
                                    padding: "0px",
                                    margin: "0px",
                                  }}
                                  className="courseContent"
                                >
                                  <Typography
                                    sx={{
                                      fontWeight: "bold",
                                      fontSize: "12px",
                                      padding: "0px",
                                    }}
                                  >
                                    {content.name}
                                  </Typography>
                                  <Typography
                                    sx={{ color: "#A409FF", fontSize: "12px" }}
                                  >
                                    {content.percent} %
                                  </Typography>
                                </Stack>
                              </AccordionSummary>
                              {content.courses.map((course) => {
                                return (
                                  <AccordionDetails sx={{ width: "100%" }}>
                                    <Stack
                                      direction="row"
                                      spacing={2}
                                      sx={{
                                        display: "flex",
                                        justifyContent: "space-between",
                                        width: "100%",
                                        alignItems: "center",
                                      }}
                                    >
                                      <Stack
                                        direction="row"
                                        spacing={1}
                                        sx={{
                                          flex: "4",
                                          display: "flex",
                                          alignItems: "start",
                                        }}
                                      >
                                        <Box>
                                          <img
                                            src="images/SRE/LearningCards/bullet.svg"
                                            className="learning-bullet-icon"
                                            alt="hexagon icon"
                                          ></img>
                                        </Box>
                                        <Button
                                          sx={{
                                            fontSize: "12px",
                                            textTransform: "none",
                                            textAlign: "start",
                                            marginLeft: "0px",
                                          }}
                                          color="primary"
                                          target="_blank"
                                          href={course.link}
                                        >
                                          {course.name}
                                        </Button>
                                      </Stack>
                                    </Stack>
                                  </AccordionDetails>
                                );
                              })}
                            </Accordion>
                          </>
                        </Stack>
                      );
                    })
                  ) : item.title === "Manual Testing Equipped" ? (
                    equippedsubParentData[1].map((content, i) => {
                      return (
                        <Stack
                          direction="column"
                          mt={1.5}
                          className="acc-stack"
                          sx={{ overflowY: "auto" }}
                        >
                          <>
                            <Accordion className="mainAccordion">
                              <AccordionSummary
                                sx={{
                                  backgroundColor: "#FFF",
                                  margin: "0px",
                                  padding: "0px",
                                }}
                                expandIcon={
                                  <ExpandMoreIcon
                                    sx={{ fontSize: "1rem", color: "#0041F0" }}
                                  />
                                }
                              >
                                <Stack
                                  direction="row"
                                  sx={{
                                    display: "flex",
                                    justifyContent: "space-between",
                                    width: "100%",
                                    padding: "0px",
                                    margin: "0px",
                                  }}
                                  className="courseContent"
                                >
                                  <Typography
                                    sx={{
                                      fontWeight: "bold",
                                      fontSize: "12px",
                                      padding: "0px",
                                    }}
                                  >
                                    {content.name}
                                  </Typography>
                                  <Typography
                                    sx={{ color: "#A409FF", fontSize: "12px" }}
                                  >
                                    {content.percent} %
                                  </Typography>
                                </Stack>
                              </AccordionSummary>
                              {content.courses.map((course) => {
                                return (
                                  <AccordionDetails sx={{ width: "100%" }}>
                                    <Stack
                                      direction="row"
                                      spacing={2}
                                      sx={{
                                        display: "flex",
                                        justifyContent: "space-between",
                                        width: "100%",
                                        alignItems: "center",
                                      }}
                                    >
                                      <Stack
                                        direction="row"
                                        spacing={1}
                                        sx={{
                                          flex: "4",
                                          display: "flex",
                                          alignItems: "start",
                                        }}
                                      >
                                        <Box>
                                          <img
                                            src="images/SRE/LearningCards/bullet.svg"
                                            className="learning-bullet-icon"
                                            alt="hexagon icon"
                                          ></img>
                                        </Box>
                                        <Button
                                          sx={{
                                            fontSize: "12px",
                                            textTransform: "none",
                                            textAlign: "start",
                                            marginLeft: "0px",
                                          }}
                                          color="primary"
                                          target="_blank"
                                          onClick={() =>
                                            content.name == "Casestudy - 1"
                                              ? handleOpenCaseStudy()
                                              : window.open(course.link)
                                          }
                                        >
                                          {course.name}
                                        </Button>
                                      </Stack>
                                      {/* <BorderLinearProgress sx={{ width: "50px", flex: "1" }}  variant="determinate" value={course.percent} /> */}
                                    </Stack>
                                  </AccordionDetails>
                                );
                              })}
                            </Accordion>
                          </>
                          {/* :<Stack direction="row" spacing={1} sx={{ flex: "4" ,display:"flex",alignItems: "center", margin:"5px 0px" }}>
                                                                <Box>
                                                                    <img src='images/SRE/LearningCards/bullet.svg' className="learningCasestudy-bullet-icon"></img>
                                                                </Box>
                                                                <Typography sx={{ fontSize: "12px" }} color="primary">Hello</Typography>
                                                            </Stack>} */}
                        </Stack>
                      );
                    })
                  ) : item.title === "Manual Testing Competent" ? (
                    competentsubParentData[2].map((content, i) => {
                      return (
                        <Stack
                          direction="column"
                          mt={1.5}
                          className="acc-stack"
                          sx={{ overflowY: "auto" }}
                        >
                          <>
                            <Accordion className="mainAccordion">
                              <AccordionSummary
                                sx={{
                                  backgroundColor: "#FFF",
                                  margin: "0px",
                                  padding: "0px",
                                }}
                                expandIcon={
                                  <ExpandMoreIcon
                                    sx={{ fontSize: "1rem", color: "#0041F0" }}
                                  />
                                }
                              >
                                <Stack
                                  direction="row"
                                  sx={{
                                    display: "flex",
                                    justifyContent: "space-between",
                                    width: "100%",
                                    padding: "0px",
                                    margin: "0px",
                                  }}
                                  className="courseContent"
                                >
                                  <Typography
                                    sx={{
                                      fontWeight: "bold",
                                      fontSize: "12px",
                                      padding: "0px",
                                    }}
                                  >
                                    {content.name}
                                  </Typography>
                                  <Typography
                                    sx={{ color: "#A409FF", fontSize: "12px" }}
                                  >
                                    {content.percent} %
                                  </Typography>
                                </Stack>
                              </AccordionSummary>
                              {content.courses.map((course) => {
                                return (
                                  <AccordionDetails sx={{ width: "100%" }}>
                                    <Stack
                                      direction="row"
                                      spacing={2}
                                      sx={{
                                        display: "flex",
                                        justifyContent: "space-between",
                                        width: "100%",
                                        alignItems: "center",
                                      }}
                                    >
                                      <Stack
                                        direction="row"
                                        spacing={1}
                                        sx={{
                                          flex: "4",
                                          display: "flex",
                                          alignItems: "start",
                                        }}
                                      >
                                        <Box>
                                          <img
                                            src="images/SRE/LearningCards/bullet.svg"
                                            className="learning-bullet-icon"
                                            alt="hexagon icon"
                                          ></img>
                                        </Box>
                                        <Button
                                          sx={{
                                            fontSize: "12px",
                                            textTransform: "none",
                                            textAlign: "start",
                                            marginLeft: "0px",
                                          }}
                                          color="primary"
                                          target="_blank"
                                          onClick={() =>
                                            content.name == "Casestudy - 2"
                                              ? handleOpenCaseStudy()
                                              : window.open(course.link)
                                          }
                                        >
                                          {course.name}
                                        </Button>
                                      </Stack>
                                      {/* <BorderLinearProgress sx={{ width: "50px", flex: "1" }}  variant="determinate" value={course.percent} /> */}
                                    </Stack>
                                  </AccordionDetails>
                                );
                              })}
                            </Accordion>
                          </>
                          {/* :<Stack direction="row" spacing={1} sx={{ flex: "4" ,display:"flex",alignItems: "center", margin:"5px 0px" }}>
                                                                        <Box>
                                                                            <img src='images/SRE/LearningCards/bullet.svg' className="learningCasestudy-bullet-icon"></img>
                                                                        </Box>
                                                                        <Typography sx={{ fontSize: "12px" }} color="primary">Hello</Typography>
                                                                    </Stack>} */}
                        </Stack>
                      );
                    })
                  ) : (
                    <Stack
                      direction="row"
                      spacing={1}
                      sx={{
                        flex: "4",
                        display: "flex",
                        alignItems: "center",
                        margin: "5px 0px",
                      }}
                    >
                      <Box>
                        <img
                          src="images/SRE/LearningCards/bullet.svg"
                          className="learningCasestudy-bullet-icon"
                          alt="hexagon icon"
                        ></img>
                      </Box>
                      <Typography sx={{ fontSize: "12px" }} color="primary" l>
                        {item.Content}
                      </Typography>
                    </Stack>
                  )}
                </Box>
              </AccordionDetails>
            </Accordion>
          </Box>
        </Card>
      </Grid>
    );
  };
  return (
    <>
      <Modal
        open={openCaseStudy}
        onClose={handleCloseCaseStudy}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={style}>
          <Button
            sx={{
              position: "absolute",
              right: "14px",
              top: "14px",
              padding: "0px 6px",
              fontSize: "14px",
              fontWeight: "bold",
              color: "whiteSmoke",
              border: "2px solid #3498DB",
              borderRadius: "4px",
            }}
            onClick={handleCloseCaseStudy}
            variant="contained"
          >
            X
          </Button>
          <Typography id="modal-modal-description">
            For Case Study details, please contact{" "}
            <a href={`mailto:${mailData.enbridge_talentAcademy_mail}`}>
              {mailData.enbridge_talentAcademy_mail}
            </a>
          </Typography>
        </Box>
      </Modal>
      <Box
        sx={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          marginTop: "20px",
        }}
      >
        <Box className="cardsWrapper">
          <Box className="mb-20">
            <h2>Three Phases of Manual Testing</h2>
            <p className="learningText">
              By providing the essential trainings, we aid in your endeavor to
              develop a prosperous learning journey. Regardless of your level of
              experience, our trainings will provide you the knowledge,
              abilities, and confidence you need to be successful in your
              testing role.
            </p>
          </Box>
          <Grid
            container
            direction={isSmallScreen ? "column" : "row"}
            spacing={2}
          >
            {mlAwareData.map((item, i) => {
              return item !== "" && item !== undefined && item !== NaN
                ? phasesData(item)
                : item !== "" &&
                    cardData.map((item) => {
                      return phasesData(item);
                    });
            })}
            {mlEquippedData.map((item, i) => {
              return item !== "" && item !== undefined && item !== NaN
                ? phasesData(item)
                : item === NaN &&
                    item !== "" &&
                    cardData.map((item) => {
                      return phasesData(item);
                    });
            })}
            {mlCompetentData.map((item, i) => {
              return item !== "" && item !== undefined && item !== NaN
                ? phasesData(item)
                : item === NaN &&
                    item !== "" &&
                    cardData.map((item) => {
                      return phasesData(item);
                    });
            })}
          </Grid>
        </Box>
      </Box>
      {/* modal */}
    </>
  );
}

export default MTLearningCards;
